import { useShopI18n } from '../../i18n'
import { CustomerAreaPageLayout } from './customer-area'

type CustomerSectionPlaceholderPageProps = {
  nestedPath: string
  onNavigate: (targetPath: string) => void
}

export const CustomerSectionPlaceholderPage = ({
  nestedPath,
  onNavigate,
}: CustomerSectionPlaceholderPageProps) => {
  const { t, toLocalizedPath } = useShopI18n()

  return (
    <CustomerAreaPageLayout containerClassName="max-w-3xl">
      <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
        <p className="text-xs uppercase tracking-[0.18em] text-emerald-700">{t('common.customerArea')}</p>
        <h1 className="mt-2 text-2xl font-semibold">{t('customer.placeholder.title')}</h1>
        <p className="mt-2 text-sm text-slate-600">
          {t('customer.placeholder.description', { nestedPath })}
        </p>
        <button
          type="button"
          onClick={() => onNavigate(toLocalizedPath('/dashboard'))}
          className="mt-4 inline-flex items-center rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:border-emerald-300 hover:text-emerald-800"
        >
          {t('customer.placeholder.back')}
        </button>
      </div>
    </CustomerAreaPageLayout>
  )
}
